export function saveDocument(): Promise<void> {
  return Word.run(async (context) => {
    try {
      context.document.save();
      await context.sync();
    } catch (error) {
      console.error(error);
    }
  });
}

export function listenForDocumentSelectionChanges(onSelectionChanged: () => void): Promise<void> {
  return new Promise((resolve, reject) => {
    Office.context.document.addHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      onSelectionChanged,
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve();
        } else {
          reject(Object.assign(new Error(), result.error));
        }
      }
    );
  });
}

export function unlistenForDocumentSelectionChanges(): Promise<void> {
  return new Promise((resolve, reject) => {
    Office.context.document.removeHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve();
        } else {
          reject(Object.assign(new Error(), result.error));
        }
      }
    );
  });
}
